<template>
    <div style="padding: 10px 20px 10px 10px;background: #ffffff;height: 100%">
        <div class="receive-title">车辆信息</div>
        <Form :model="formCar" :label-width="100" ref="formCar" :rules="rulesCar">
            <Row>
                <Col span="4">
                    <FormItem label="车牌号" prop="plateNumber" class="my-form-item">
                        <Input v-model="formCar.plateNumber"
                               placeholder="请输入车牌号"
                               @on-keyup="onPlateKeyUp"
                               @on-blur="onPlateChange"></Input>
                    </FormItem>
                </Col>
                <Col span="2">
                    <Button icon="md-search" type="primary" class="my-input-button" size="small" @click="onPlateChange">查询</Button>
                </Col>
                <Col span="6">
                    <FormItem label="VIN码" prop="vinCode" class="my-form-item">
                        <Input v-model="formCar.vinCode" placeholder="请输入VIP码"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="车辆类型" prop="carType" class="my-form-item">
                        <Select v-model="formCar.carType" filterable>
                            <Option v-for="item in carTypeList" :value="item.dictValue" :key="item.dictValue">{{ item.dictName }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="发动机号" prop="engineCode" class="my-form-item">
                        <Input v-model="formCar.engineCode" placeholder="请输入发动机号"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="汽车品牌" prop="carBrand" class="my-form-item">
                        <Input v-model="formCar.carBrand" placeholder="请输入汽车品牌"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="车系" prop="carSeries" class="my-form-item">
                        <Input v-model="formCar.carSeries" placeholder="请输入车系"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="排量" prop="displacement" class="my-form-item">
                        <Input v-model="formCar.displacement" placeholder="请输入排量"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="生产年份" prop="productYear" class="my-form-item">
                        <Input v-model="formCar.productYear" placeholder="请输入生产年份"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="6">
                    <FormItem label="车险到期" prop="insuranceDate" class="my-form-item">
                        <DatePicker v-model="formCar.insuranceDate" format="yyyy-MM-dd"
                                    type="date" placeholder="请选择车险到期日"
                                    class="my-form-input" @on-change="handleCxChange"/>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="年检日期" prop="inspectionDate" class="my-form-item">
                        <DatePicker v-model="formCar.inspectionDate" type="date" format="yyyy-MM-dd"
                                    placeholder="请选择年检日期"
                                    class="my-form-input" @on-change="handleCjChange"/>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div class="receive-title">
            <span>客户信息</span>
            <div class="member-title-phone">
                <span v-for="(item, index) in memberList"
                      :key="index" style="margin-left: 20px"
                      :style="{color: item.color}" @click="memberListClick(item)">
                    {{ item.name }}({{ item.phone }})
                </span>
            </div>
        </div>
        <Form :model="formMember" :label-width="100" ref="formMember" :rules="rulesMember">
            <Row>
                <Col span="4">
                    <FormItem label="电话号码" prop="phone" class="my-form-item">
                        <Input v-model="formMember.phone" placeholder="请输入电话号码" @on-blur="onPhoneChange(1)"></Input>
                    </FormItem>
                </Col>
                <Col span="2">
                    <Button icon="md-search" type="primary" class="my-input-button" size="small" @click="onPhoneChange(2)">查询</Button>
                </Col>
                <Col span="6">
                    <FormItem label="姓名" prop="name" class="my-form-item">
                        <Input v-model="formMember.name" placeholder="请输入姓名"></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div class="receive-title">工单信息</div>
        <Form :model="formOrder" :label-width="100" ref="formOrder" :rules="rulesOrder">
            <Row>
                <Col span="6">
                    <FormItem label="维修类型" prop="repairType" class="my-form-item">
                        <Select v-model="formOrder.repairType" filterable>
                            <Option v-for="item in repairTypes" :value="item.dictValue" :key="item.dictValue">
                                {{ item.dictName }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="接车时间" prop="receiveDate" class="my-form-item">
                        <DatePicker type="datetime" format="yyyy-MM-dd HH:mm:ss" v-model="defaultReceiveTime"
                                    placeholder="请选择接车时间" class="my-form-input" @on-change="handleReceiveChange"/>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="预计完成时间" prop="preCompleteDate" class="my-form-item">
                        <DatePicker type="datetime" format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择预计完成时间" class="my-form-input" @on-change="handlePreChange"/>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="进厂里程(KM)" prop="name" class="my-form-item">
                        <Input type="number" v-model="formOrder.entryMileage" placeholder="请输入进厂里程"></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div style="background: #f3f7fd; padding: 10px 0; text-align: right">
            <Button icon="md-checkmark" type="primary" @click="handleOk">确定接车</Button>
        </div>

    </div>
</template>

<script>
import {queryReceiveInitInfo} from "@/api/baseData"
import {queryCar, queryMemberByPhone, receiveCar} from "@/api/business"

export default {
    name: "ReceiveCar",
    data() {
        return {
            formCar: {
                plateNumber: '',
                vinCode: '',
                carType: '',
                engineCode: '',
                carBrand: '',
                carSeries: '',
                displacement: '',
                productYear: '',
                insuranceDate: '',
                inspectionDate: '',
            },
            formMember: {
                name: '',
                phone: '',
            },
            formOrder: {
                receiveDate: '',
                preCompleteDate: '',
                repairType: '',
            },
            defaultReceiveTime: new Date(),
            carTypeList: [],
            itemClassifyList: [],
            repairTypes: [],
            rulesCar: {
                plateNumber: [
                    {required: true, message: '车牌号不能为空', trigger: 'blur'},
                ],
                carType: [
                    {required: true, message: '车辆类型不能为空', trigger: 'blur'},
                ],
            },
            rulesMember: {
                name: [
                    {required: true, message: '姓名不能为空', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '电话号码不能为空', trigger: 'blur'},
                ],
            },
            rulesOrder: {
                repairType: [
                    {required: true, message: '维修分类不能为空', trigger: 'blur'},
                ],
            },
            memberList: [],
        }
    },
    mounted() {
        this.initInfo()
    },
    methods: {
        async initInfo() {
            let {data} = await queryReceiveInitInfo()
            this.carTypeList = data.carTypeList
            this.repairTypes = data.repairTypeList
            this.itemClassifyList = data.itemClassifies
        },
        resetCarForm() {
            const tmpPlate = this.formCar.plateNumber
            this.formCar = {
                plateNumber: '',
                vinCode: '',
                carType: '',
                engineCode: '',
                carBrand: '',
                carSeries: '',
                displacement: '',
                productYear: '',
                insuranceDate: '',
                inspectionDate: '',
            }
            this.formCar.plateNumber = tmpPlate
        },
        resetMemberForm() {
            const tmpPhone = this.formMember.phone
            this.formMember = {
                phone: '',
                name: '',
            }
            this.formMember.phone = tmpPhone
        },
        async handleOk() {
            let resCar = await this.$refs.formCar.validate()
            let resMember = await this.$refs.formMember.validate()
            let resOrder = await this.$refs.formOrder.validate()
            if (!resCar || !resMember || !resOrder) {
                return
            }
            this.formCar.id = undefined
            this.formMember.id = undefined
            // eslint-disable-next-line no-restricted-syntax
            for (let item of this.repairTypes) {
                if (item.dictValue === this.formOrder.repairType) {
                    this.formOrder.repairTypeName = item.dictName
                }
            }
            let param = {
                carInfo: this.formCar,
                memberInfo: this.formMember,
                workOrder: this.formOrder,
            }
            receiveCar(param).then((res) => {
                this.$Message.success({
                    background: true,
                    content: '接车成功',
                })
                this.$router.push({path: '/repairInfo', query: {orderNumber: res.data.orderNumber}})
            })
        },
        handleReceiveChange(date) {
            this.formOrder.receiveDate = date
        },
        handlePreChange(date) {
            this.formOrder.preCompleteDate = date
        },
        handleCxChange(date) {
            this.formCar.insuranceDate = date
        },
        handleCjChange(date) {
            this.formCar.inspectionDate = date
        },
        onPlateChange() {
            if (this.formCar.plateNumber.length === 0) {
                return
            }
            queryCar({plateNumber: this.formCar.plateNumber}).then((res) => {
                if (res.data.carInfo) {
                    this.formCar = res.data.carInfo
                } else {
                    this.resetCarForm()
                }
                if (res.data.memberInfoList && res.data.memberInfoList.length > 0) {
                    if (res.data.memberInfoList.length > 1) {
                        this.memberList = res.data.memberInfoList
                        this.formMember = this.memberList[0]
                        this.formMember.color = '#a90abb'
                        this.formMember.id = undefined
                    } else if (res.data.memberInfoList.length === 1) {
                        this.memberList = []
                        this.formMember = res.data.memberInfoList[0]
                        this.formMember.id = undefined
                    } else {
                        this.memberList = []
                    }
                } else {
                    this.memberList = []
                    this.formMember = {
                        phone: '',
                        name: '',
                    }
                }
            })
        },
        onPlateKeyUp() {
            this.formCar.plateNumber = this.formCar.plateNumber.toUpperCase()
        },
        onPhoneChange(flag) {
            if (this.formMember.phone.length === 0) {
                return
            }
            if (flag === 1) {
                if (this.formMember.name.length > 0) {
                    return
                }
            }
            queryMemberByPhone({phone: this.formMember.phone}).then((res) => {
                if (res.data !== null) {
                    this.formMember = res.data
                } else {
                    this.resetMemberForm()
                }
            })
        },
        memberListClick(item) {
            // eslint-disable-next-line no-restricted-syntax
            for (let m of this.memberList) {
                if (m.phone === item.phone) {
                    m.color = '#a90abb'
                    this.formMember = Object.assign({}, m)
                    this.formMember.id = undefined
                } else {
                    m.color = '#044aa1'
                }
            }
            this.$forceUpdate()
        },
    },
}
</script>

<style scoped>
.receive-title {
    font-size: 14px;
    font-weight: bold;
    background: #f3f7fd;
    padding: 5px 0;
    margin-bottom: 10px;
    color: #2d8cf0;
}

.my-form-item {
    /*margin-left: 10px;*/
}

.my-input-button {
    margin-top: 2px;
    margin-left: 6px;
    height: 30px;
}

.member-title-phone {
    display: inline-block;
    padding-left: 20px;
    cursor: pointer;
    color: #044aa1;
    font-size: 13px;
}
</style>
